import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA1ANn9QEaIjIYZarKbpH6bP2REy-EzhgY",
  authDomain: "halici-295d4.firebaseapp.com",
  projectId: "halici-295d4",
  storageBucket: "halici-295d4.firebasestorage.app",
  messagingSenderId: "220356838459",
  appId: "1:220356838459:web:0fc31742ede9e4d5f5c81e",
  measurementId: "G-55EVX7R813"
};

const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true
});